import {
    useCallback,
} from 'react'

import {
    RoutesConfig,
} from 'app/SkyNetRoutes/SkyNetRoutes.types'
import useContactManagementRoutes from 'app/SkyNetRoutes/hooks/useContactManagementRoutes'

import ContactForm from '../ContactForm/ContactForm'
import useCreateContact from '../hooks/useCreateContact'
import {
    Contact,
} from '../Contacts.types'

const ContactCreate = () => {
    const {
        Contacts: ContactsRoutes,
    } = useContactManagementRoutes()

    const onCreateContactSuccess = useCallback((contact: { id: number }, payload: Contact) => {
        if (payload.isProspect) {
            (ContactsRoutes.Prospect as Record<string, RoutesConfig>).Edit.Overview.navigate({
                params: {
                    key: contact.id,
                },
            })
            return
        }

        ContactsRoutes.Overview.navigate({
            params: {
                key: contact.id,
            },
        })
    }, [ContactsRoutes])

    const createContact = useCreateContact({
        onSuccess: onCreateContactSuccess,
    })

    return (
        <ContactForm action={createContact} />
    )
}

export default ContactCreate
